export default __webpack_public_path__ + "static/media/hr2.a15d4c28.png";